import React, { useState } from 'react';
import { Form, Input, Button, Typography, Card, Alert, message, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../AuthContext';
import CreateUserPage from './CreateUserPage';

const { Title, Text } = Typography;

const LoginPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [errorAlert, setErrorAlert] = useState({ visible: false, message: '' });
  const { login } = useAuth();

  const handleLogin = async (values) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/login`,
        { email: values.email, password: values.password },
        { withCredentials: true }
      );
      if (response.status === 200) {
        message.success('Login successful!');
        setErrorAlert({ visible: false, message: '' });
        login(); 
        navigate('/ui/dashboard');
      }
    } catch (error) {
      setErrorAlert({
        visible: true,
        message: error.response?.data?.reason ?? 'Login failed. Check your credentials.',
      });
    }
  };

  const handleClick = () => {
    navigate('/ui/user/create');
  };

    const handlePasswordClick = () => {
    navigate('/ui/user/password');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f6f6f6' }}>
      <Card style={{ width: 650, padding: '40px 40px 32px 40px' }}>
        <Title level={2}>Login to Food</Title>
        <Text>This service requires Authentication. Enter your email and password or create a new account.</Text>

        {errorAlert.visible && (
          <Alert style={{ marginTop: 16, marginBottom: 24 }} message={errorAlert.message} type="error" closable onClose={() => setErrorAlert({ ...errorAlert, visible: false })} />
        )}

        <Form form={form} name="login" layout="vertical" onFinish={handleLogin}>
          <Form.Item label="Email" name="email" rules={[{ required: true, message: 'Please enter your email!' }]}>
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Please enter your password!' }]}>
            <Input.Password placeholder="Password" />
          </Form.Item>
<Form.Item>
  <Button type="primary" htmlType="submit" block>
    Login
  </Button>
</Form.Item>
<Form.Item>
  <Row gutter={8}>
    <Col span={12}>
      <Button type="default" block onClick={handleClick}>
        Create User
      </Button>
    </Col>
    <Col span={12}>
      <Button type="default" block onClick={handlePasswordClick}>
        Forgot Password
      </Button>
    </Col>
  </Row>
</Form.Item>
</Form>
      </Card>
    </div>
  );
};

export default LoginPage;
